import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import api from './api/index';
import mixin from './assets/js/mixin';
import './assets/css/common.scss';
import './assets/css/glass-theme.scss';
import './icons'; // svg-icon component
import echarts from 'echarts';
import 'babel-polyfill';
// import msg from './assets/js/login';
Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.use(ElementUI);
Vue.mixin(mixin);
Vue.prototype.$echarts = echarts;
Vue.prototype.$api = api;
// Vue.prototype.$mgr = msg;
Vue.prototype.$messageSuccess = function(text) {
  ElementUI.Message.success({
    message: text,
    showClose: true,
    duration: 1000,
    offset: 350
  });
};
Vue.prototype.$messageError = function(text) {
  if (!text) {
    return;
  }
  ElementUI.Message.error({
    message: text,
    showClose: true,
    duration: 1500,
    offset: 350
  });
};
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
